
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.64 11.02C16.19 9.55004 17.07 8.24004 18.2 7.19004C18.58 6.83004 18.24 6.19004 17.74 6.34004C14.42 7.32004 11.99 10.39 12 14.03C12.95 12.75 14.2 11.72 15.64 11.02ZM11.42 8.85004C10.82 7.29004 9.79 5.94004 8.46 4.98004C8.04 4.68004 7.5 5.17004 7.74 5.63004C8.54 7.15004 9 8.88004 9 10.71C9 10.92 8.97 11.12 8.96 11.32C9.39 11.56 9.79 11.84 10.18 12.14C10.39 10.96 10.83 9.85004 11.42 8.85004ZM12 20H3C2.45 20 2 19.55 2 19C2 18.45 2.45 18 3 18H7.75C7.18 15.81 5.71 13.98 3.75 12.94C3.59 12.86 3.49 12.69 3.49 12.5C3.49 12.23 3.71 12.01 3.98 12C3.99 12 4 12 4 12C8.42 12 12 15.58 12 20ZM20.26 12.94C18.3 13.98 16.82 15.81 16.26 18H21C21.55 18 22 18.45 22 19C22 19.55 21.55 20 21 20H16H14C14 19.32 13.93 18.65 13.8 18C13.65 17.28 13.42 16.58 13.13 15.93C14.52 13.58 17.07 12 20 12C20.01 12 20.02 12 20.02 12C20.29 12 20.51 12.23 20.51 12.5C20.52 12.69 20.41 12.85 20.26 12.94Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-grass`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconGrass

    ```js
    <b-new-b-icon-grass />
    ```
</docs>


